import { useEffect } from 'react'

import { trackUserAddress } from '@/domain/analytics/mixpanel'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'

export function useTrackAccount(): void {
  const { account: address } = useConnectedAddress({ throwOnNotConnected: false })
  useEffect(() => {
    if (address) {
      trackUserAddress(address)
    }
  }, [address])
}
